import { useState, useCallback, useEffect, useMemo } from 'react'
import { useStatsConsult } from '@/app/hooks/useStatsConsult'
import { useConsultsMutations } from '@/app/hooks/useConsultsMutations'

export function useConsultSettingsController() {
  const { data, isLoading } = useStatsConsult()
  const { configureConsultMutation, deleteAllConsultsMutation } =
    useConsultsMutations()
  const [isSelected, setIsSelected] = useState({
    j17: false,
    qitech: false,
    qitech180: false,
  })

  const setInitialState = useCallback(
    ({
      j17,
      qitech,
      qitech180,
    }: {
      j17: boolean
      qitech: boolean
      qitech180: boolean
    }) => {
      setIsSelected({ j17, qitech, qitech180 })
    },
    [],
  )

  const handleToggle = (type: keyof typeof isSelected) => {
    const newValue = !isSelected?.[type]
    configureConsultMutation.mutate({ [type]: newValue })
    setIsSelected((prev) => ({ ...prev, [type]: newValue }))
  }

  const handleDeleteAllConsults = () => {
    deleteAllConsultsMutation.mutate()
  }

  useEffect(() => {
    if (data) {
      setInitialState({
        j17: data.j17,
        qitech: data.qitech,
        qitech180: data.qitech180,
      })
    }
  }, [data, setInitialState])

  const buttons = useMemo(
    () => [
      {
        label: 'J17',
        sublabel: '60',
        isSelect: isSelected.j17,
        onClick: () => handleToggle('j17'),
      },
      {
        label: 'QI Tech',
        sublabel: '120',
        isSelect: isSelected.qitech,
        onClick: () => handleToggle('qitech'),
      },
      {
        label: 'QI Tech',
        sublabel: '180',
        isSelect: isSelected.qitech180,
        onClick: () => handleToggle('qitech180'),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isSelected],
  )

  return {
    data,
    isLoading,
    buttons,
    handleDeleteAllConsults,
  }
}
